import {
    useLayoutEffect,
    useEffect,
    useState
} from "react";
import {
    TouchableOpacity,
    ActivityIndicator,
    View,
    Image,
    Platform
} from "react-native";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    PageContainer,
    TextAreaInput,
    DateTimePicker,
    SelectBox,
    TextInput,
    Button,
    Dialog,
    Text,
    NCoreUIKitToast
} from "ncore-ui-kit";
import {
    useNavigation,
    useRoute,
    type RouteProp
} from "@react-navigation/native";
import {
    useSafeAreaInsets
} from "react-native-safe-area-context";
import type {
    EditCommercialOpportunityRequestType
} from "../../../../../services/restAPI/actions/editCommercialOpportunity/types";
import type {
    NewCommercialOpportunityRequestType
} from "../../../../../services/restAPI/actions/newCommercialOpportunity/types";
import type AppStackParamList from "../../../../../types/navigation/app";
import type {
    SelectedFileType
} from "../../../editProfile/type";
import type {
    NativeStackNavigationProp
} from "@react-navigation/native-stack";
import {
    ArrowLeftRight,
    ChevronLeft,
    PencilOff,
    Percent,
    Pencil,
    Check
} from "lucide-react-native";
import ImageCropPicker from "react-native-image-crop-picker";
import validator from "validator";
import Linear from "../../../../../assets/images/linear2.png";
import {
    RESTService
} from "../../../../../services/restAPI";
import {
    handleUpload
} from "../../../../../utils";

const EditCampaign = () => {
    const navigation = useNavigation<NativeStackNavigationProp<AppStackParamList>>();

    const route = useRoute<RouteProp<AppStackParamList, "EditCampaign">>();

    const {
        campaignDetail
    } = route.params;

    const {
        radiuses,
        borders,
        spaces,
        colors
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const inset = useSafeAreaInsets();

    const [updateParams,
        setUpdateParams] = useState<NewCommercialOpportunityRequestType>({
            companyID: campaignDetail.companyID,
            description: campaignDetail.description,
            discountRate: campaignDetail.discountRate,
            endDate: campaignDetail.endDate,
            title: campaignDetail.title
        });
    const [myCompanies,
        setMyCompanies] = useState<Array<{companyID: string; companyTitle: string;}>>([]);
    const [successDialog,
        setSuccessDialog] = useState(false);
    const [verificationDialog,
        setVerificationDialog] = useState(false);
    const [cancelSuccessDialog,
        setCancelSuccessDialog] = useState(false);
    const [cancelVerificationDialog,
        setCancelVerificationDialog] = useState(false);
    const [loading,
        setLoading] = useState(true);
    const [selectedImage,
        setSelectedImage] = useState<string | null>(null);
    const [selctedFile,
        setSelectedFile] = useState<SelectedFileType | null>(null);

    useEffect(() => {
        getCompanies();
    }, []);

    useLayoutEffect(() => {
        navigation.setOptions({
            headerShown: true,
            header: () => <View
                style={[
                    stylesheet.headerWrapper,
                    {
                        paddingTop: inset.top,
                        paddingHorizontal: spaces.spacingMd,
                        backgroundColor: colors.content.container.default
                    }
                ]}
            >
                <TouchableOpacity
                    style={[
                        stylesheet.backButton,
                        {
                            padding: spaces.spacingSm
                        }
                    ]}
                    onPress={() => {
                        navigation.goBack();
                    }}
                >
                    <ChevronLeft
                        size={30}
                    />
                </TouchableOpacity>
                <View
                    style={[
                        stylesheet.headerTitleContainer,
                        {
                            top: inset.top + spaces.spacingSm
                        }
                    ]}
                >
                    <Text
                        variant="titleLargeSize"
                        color="high"
                        style={stylesheet.headerTitle}
                    >
                        {localize("editCampaign-title")}
                    </Text>
                </View>
            </View>
        });
    }, [navigation]);

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    const editCommercialOpportunity = () => {
        if(!updateParams){
            if(selctedFile) {
                handleUploadCoverPhoto(campaignDetail._id);
                return;
            }
            return;
        }

        const params : EditCommercialOpportunityRequestType = {
            opportunityID: campaignDetail._id
        };

        if(updateParams.description && updateParams.description.length && campaignDetail.description !== updateParams.description) {
            params.description = updateParams.description;
        }

        if(updateParams.title && updateParams.title.length && campaignDetail.title !== updateParams.title) {
            params.title = updateParams.title;
        }

        if(updateParams.endDate && updateParams.endDate.length && validator.isDate(updateParams.endDate) && campaignDetail.endDate !== updateParams.endDate) {
            params.endDate = updateParams.endDate;
        }

        if(updateParams.discountRate > 0 && updateParams.discountRate < 101 && updateParams.discountRate !== campaignDetail.discountRate) {
            params.discountRate = updateParams.discountRate;
        }

        RESTService.action("EditCommercialOpportunity", params)
            .then((res) => {
                if(res.code === 200 || res.code === 201 || res.code === 202) {
                    if(selctedFile) {
                        handleUploadCoverPhoto(params.opportunityID);
                        return;
                    }
                    setSuccessDialog(true);
                }
            }).catch((err) => {
                console.log(err);
            });
    };

    const removeCommercialOpportunity = () => {
        RESTService.action("RemoveCommercialOpportunity", {
            opportunityID: campaignDetail._id
        }).then((res) => {
            if(res.code === 200 || res.code === 201 || res.code === 202) {
                setCancelSuccessDialog(true);
            }
        }).catch((err) => {
            console.log(err);
        });
    };

    const getCompanies = () => {
        RESTService.action("GetMyCompanies", null)
            .then((res) => {
                if(res.code === 200 || res.code === 201 || res.code === 202) {
                    setMyCompanies(res.payload);
                    setLoading(false);
                }
            }).catch((err) => {
                console.log(err);
            });
    };

    const handleUploadCoverPhoto = (reqID: string) => {
        if(!selctedFile) {
            return;
        }

        RESTService.action("CampaignCoverPhotoUpdate", {
            requestID: reqID
        })
            .then(async (res) => {
                if(res.code === 200 || res.code === 201 || res.code === 202) {

                    await handleUpload(selctedFile, res.payload.uploadToken)
                        .then(() => {
                            setSuccessDialog(true);
                        })
                        .catch((err) => {
                            console.log("err", err);
                            throw err;
                        });
                }
            }).catch((err) => {
                console.log("err", err);
            });
    };

    const renderCampaignCard = () => {
        return <View
            style={{
                marginBottom: spaces.spacingLg
            }}
        >
            <Image
                source={{
                    uri: selectedImage ? selectedImage: campaignDetail.coverPhotoURL
                }}
                resizeMode="cover"
                style={{
                    ...stylesheet.campaignLogo,
                    borderRadius: radiuses.md
                }}
            />
            <Image
                source={Linear}
                style={[
                    {
                        ...stylesheet.coverphoto,
                        borderRadius: radiuses.md
                    }
                ]}
            />
            <TouchableOpacity
                style={[
                    stylesheet.editImageButton,
                    {
                        backgroundColor: colors.content.container.default,
                        borderColor: colors.content.border.subtle,
                        borderRadius: radiuses.full,
                        borderWidth: borders.line,
                        padding: spaces.spacingSm,
                        right: spaces.spacingLg,
                        top: spaces.spacingLg
                    }
                ]}
                onPress={() => {
                    ImageCropPicker.openPicker({
                        cropping: true,
                        multiple: false
                    }).then(image => {
                        const format = image.mime?.split("/")[1];

                        if (image.size > 20 * 1024 * 1024) {
                            NCoreUIKitToast.open({
                                title: localize("imageTooLarge"),
                                type: "warning"
                            });
                            return;
                        }

                        if (![
                            "jpg",
                            "jpeg",
                            "png",
                            "heic"
                        ].includes(format as string)) {
                            NCoreUIKitToast.open({
                                title: localize("invalidFormat"),
                                type: "warning"
                            });
                            return;
                        }

                        const selectedFile = {
                            name: image.path.split("/").pop(),
                            type: image.mime,
                            uri: Platform.OS === "ios" ? image.path.startsWith("file://") ? image.path : `file:/${image.path}` : image.path
                        } as unknown as { name: string; type: string; uri: string; };
                        setSelectedImage(image.path);
                        setSelectedFile(selectedFile);
                    }).catch((err) => {
                        console.error(err);
                    });
                }}
            >
                <Pencil
                    size={14}
                />
            </TouchableOpacity>
            <View
                style={[
                    stylesheet.campaignTag,
                    {
                        left: spaces.spacingMd,
                        bottom: spaces.spacingMd
                    }
                ]}
            >
                <Text
                    color="onPrimary"
                    variant="bodyMediumSize"
                >
                    {updateParams?.title}
                </Text>
                <Text
                    color="onPrimary"
                    variant="bodyMediumSize"
                >
                    {updateParams?.description}
                </Text>
            </View>
        </View>;
    };

    const renderInputs = () => {
        return <View
            style={{
                marginBottom: spaces.spacingMd
            }}
        >
            <TextInput
                title={localize("campaignTitle")}
                type={updateParams.title !== campaignDetail.title && (!updateParams.title || updateParams.title.length === 0) ? "danger" : "default"}
                hintText={updateParams.title !== campaignDetail.title && (!updateParams.title || updateParams.title.length === 0) ? (localize("campaignTitleRequired")) : undefined}
                defaultValue={campaignDetail.title}
                spreadBehaviour="stretch"
                onChangeText={(e) => {
                    setUpdateParams({
                        ...updateParams,
                        title: e
                    });
                }}
                style={{
                    marginBottom: spaces.spacingMd
                }}
            />
            <TextAreaInput
                title={localize("description")}
                type={updateParams.description !== campaignDetail.description && (!updateParams.description || updateParams.description.length === 0) ? "danger" : "default"}
                hintText={updateParams.description !== campaignDetail.description && (!updateParams.description || updateParams.description.length === 0) ? (localize("descriptionRequired")) : undefined}
                spreadBehaviour="stretch"
                defaultValue={campaignDetail.description}
                onChangeText={(e) => {
                    setUpdateParams({
                        ...updateParams,
                        description: e
                    });
                }}
                style={{
                    marginBottom: spaces.spacingMd
                }}
            />
            <TextInput
                title={localize("discountRate")}
                type={updateParams.discountRate !== campaignDetail.discountRate && (!updateParams.discountRate || updateParams.discountRate <= 0 || updateParams.discountRate > 100) ? "danger" : "default"}
                hintText={updateParams.discountRate !== campaignDetail.discountRate && (!updateParams.discountRate || updateParams.discountRate <= 0 || updateParams.discountRate > 100) ? (localize("invalidDiscountRate")) : undefined}
                inputMode="numeric"
                spreadBehaviour="stretch"
                defaultValue={String(campaignDetail.discountRate)}
                icon={() => <Percent
                    size={12}
                />}
                onChangeText={(e) => {
                    if(Number(e)) {
                        setUpdateParams({
                            ...updateParams,
                            discountRate: Number(e)
                        });
                    }
                }}
                style={{
                    marginBottom: spaces.spacingMd
                }}
            />
            <DateTimePicker
                variant="single"
                spreadBehaviour="stretch"
                title={localize("campaignEndDate")}
                isWorkWithRealtime={false}
                initialDate={new Date(updateParams.endDate)}
                minDate={new Date()}
                onChange={(e) => {
                    setUpdateParams({
                        ...updateParams,
                        endDate: (e.date as Date)?.toISOString() || ""
                    });
                }}
                style={{
                    marginBottom: spaces.spacingMd
                }}
            />
            <SelectBox
                initialSelectedItems={[
                    {
                        __key: campaignDetail.companyTitle,
                        __title: campaignDetail.companyTitle
                    }
                ]}
                keyExtractor={(item) => item.companyID}
                titleExtractor={(item) => item.companyTitle}
                spreadBehaviour="stretch"
                data={myCompanies}
                title={localize("selectCompany")}
                isWorkWithRealtime={false}
                isCleanEnabled={false}
                minChoice={1}
                maxChoice={1}
                isMultipleSelect={false}
                selectSheetProps={{
                    style:{
                        borderTopRightRadius: radiuses.sm,
                        borderTopLeftRadius: radiuses.sm
                    }
                }}
                onOk={(
                    selectedItems
                ) => {
                    if(selectedItems && selectedItems.length) {
                        const companyID = selectedItems[0]?.__key;
                        if(companyID) {
                            setUpdateParams({
                                ...updateParams,
                                companyID: companyID
                            });
                        }
                    }
                }}
                style={{
                    marginBottom: spaces.spacingMd
                }}
            />
        </View>;
    };

    const renderActionButtons = () => {
        return <View
            style={[
                stylesheet.actionButtonsContainer,
                {
                    marginBottom: spaces.spacingMd
                }
            ]}
        >
            <Button
                title={localize("updateEditRequest")}
                customColor="black"
                customBorderColor="black"
                onPress={() => {
                    setVerificationDialog(true);
                }}
                spreadBehaviour="stretch"
                style={{
                    marginBottom: spaces.spacingMd
                }}
            />
            <Button
                title={localize("cancelEditRequest")}
                onPress={() => {
                    setCancelVerificationDialog(true);
                }}
                customColor={colors.project.gold}
                customTextColor={colors.project.brandWhite}
                customBorderColor={colors.project.gold}
                spreadBehaviour="stretch"
                style={{
                    marginBottom: spaces.spacingMd
                }}
            />
        </View>;
    };

    const renderSuccessDialog = () => {
        return <Dialog
            headerComponent={<View
                style={stylesheet.dialogHeader}
            >
                <View
                    style={[
                        stylesheet.successIconContainer,
                        {
                            backgroundColor: colors.system.low.success,
                            padding: spaces.spacingMd,
                            marginBottom: spaces.spacingLg,
                            borderRadius: radiuses.full
                        }
                    ]}
                >
                    <Check
                        size={30}
                        color={colors.project.brandPrimary}
                    />
                </View>
                <Text
                    variant="titleLargeSize"
                    color="high"
                >
                    {localize("submittedSuccessfully")}
                </Text>
            </View>}
            content={localize("changesUnderReview")}
            isVisible={successDialog}
            onOverlayPress={() => {
                setSuccessDialog(false);
                navigation.navigate("Profile");
            }}
            primaryButtonProps={{
                onPress: () => {
                    setSuccessDialog(false);
                    navigation.goBack();
                },
                customColor: colors.project.brandPrimary,
                customTextColor: colors.project.brandWhite,
                customBorderColor: colors.project.brandPrimary,
                title: localize("backToHome")
            }}
            variant="ok"
        />;
    };

    const renderVerificationDialog = () => {
        return <Dialog
            headerComponent={<View
                style={stylesheet.dialogHeader}
            >
                <View
                    style={[
                        stylesheet.dialogIconContainer,
                        {
                            backgroundColor: colors.system.low.success,
                            padding: spaces.spacingMd,
                            marginBottom: spaces.spacingLg,
                            borderRadius: radiuses.full
                        }
                    ]}
                >
                    <ArrowLeftRight
                        size={40}
                        color={colors.project.brandPrimary}
                    />
                </View>
                <Text
                    variant="titleLargeSize"
                    color="high"
                    style={stylesheet.textCenter}
                >
                    {localize("confirmCancelEditRequest")}
                </Text>
            </View>}
            content={localize("submitForApprovalDescription")}
            isVisible={verificationDialog}
            onOverlayPress={() => {
                setVerificationDialog(false);
            }}
            primaryButtonProps={{
                onPress: () => {
                    setVerificationDialog(false);
                    editCommercialOpportunity();
                },
                customColor: colors.project.brandPrimary,
                customTextColor: colors.project.brandWhite,
                customBorderColor: colors.project.brandPrimary,
                title: localize("update")
            }}
            secondaryButtonProps={{
                title: localize("abandon"),
                customColor: colors.project.brandWhite,
                customTextColor: colors.project.black,
                customBorderColor: colors.project.black,
                onPress: () => {
                    setVerificationDialog(false);
                }
            }}
            variant="yes-no"
        />;
    };

    const renderCancelSuccessDialog = () => {
        return <Dialog
            headerComponent={<View
                style={stylesheet.dialogHeader}
            >
                <View
                    style={[
                        stylesheet.successIconContainer,
                        {
                            backgroundColor: colors.system.low.warning,
                            padding: spaces.spacingMd,
                            marginBottom: spaces.spacingLg,
                            borderRadius: radiuses.full
                        }
                    ]}
                >
                    <Check
                        size={30}
                        color={colors.project.gold}
                    />
                </View>
                <Text
                    variant="titleLargeSize"
                    color="high"
                >
                    {localize("requestCancelled")}
                </Text>
            </View>}
            content={localize("editRequestWithdrawn")}
            isVisible={cancelSuccessDialog}
            onOverlayPress={() => {
                setCancelSuccessDialog(false);
                navigation.goBack();
            }}
            primaryButtonProps={{
                onPress: () => {
                    setCancelSuccessDialog(false);
                    navigation.goBack();
                },
                customColor: colors.project.gold,
                customTextColor: colors.project.brandWhite,
                customBorderColor: colors.project.gold,
                title: localize("goBack")
            }}
            variant="ok"
        />;
    };

    const renderCancelVerificationDialog = () => {
        return <Dialog
            headerComponent={<View
                style={stylesheet.dialogHeader}
            >
                <View
                    style={[
                        stylesheet.dialogIconContainer,
                        {
                            backgroundColor: colors.system.low.warning,
                            padding: spaces.spacingMd,
                            marginBottom: spaces.spacingLg,
                            borderRadius: radiuses.full
                        }
                    ]}
                >
                    <PencilOff
                        size={40}
                        color={colors.project.gold}
                    />
                </View>
                <Text
                    variant="titleLargeSize"
                    color="high"
                    style={stylesheet.textCenter}
                >
                    {localize("confirmCancelEditRequest")}
                </Text>
            </View>}
            content={localize("cancelEditRequestDescription")}
            isVisible={cancelVerificationDialog}
            onOverlayPress={() => {
                setCancelVerificationDialog(false);
            }}
            primaryButtonProps={{
                onPress: () => {
                    setCancelVerificationDialog(false);
                    removeCommercialOpportunity();
                },
                customColor: colors.project.gold,
                customTextColor: colors.project.brandWhite,
                customBorderColor: colors.project.gold,
                title: localize("cancel")
            }}
            secondaryButtonProps={{
                title: localize("abandon"),
                customColor: colors.project.brandWhite,
                customTextColor: colors.project.black,
                customBorderColor: colors.project.black,
                onPress: () => {
                    setCancelVerificationDialog(false);
                }
            }}
            variant="yes-no"
        />;
    };

    if(loading) {
        return <PageContainer>
            <ActivityIndicator
                size={"large"}
                color={colors.content.icon.default}
            />
        </PageContainer>;
    }

    return <PageContainer
        backgroundColor="default"
        isScrollable={
            true
        }
        scrollViewProps={{
            showsVerticalScrollIndicator: false,
            showsHorizontalScrollIndicator: false
        }}
    >
        {renderCampaignCard()}
        {renderInputs()}
        {renderActionButtons()}
        {renderSuccessDialog()}
        {renderVerificationDialog()}
        {renderCancelSuccessDialog()}
        {renderCancelVerificationDialog()}
    </PageContainer>;
};
export default EditCampaign;
